import { render } from "./IncomingCall.vue?vue&type=template&id=7eda9426&scoped=true"
import script from "./IncomingCall.vue?vue&type=script&lang=js"
export * from "./IncomingCall.vue?vue&type=script&lang=js"

import "./IncomingCall.vue?vue&type=style&index=0&id=7eda9426&scoped=true&lang=css"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eda9426"]])

export default __exports__